export const SAVE_VIDEO_MASKS_BATCH_SIZE = 128;
